export enum StitchIframeMessage {
  AccountAdded = 'account_added',
  ManualReview = 'manual_review',
}

export enum StitchPayoutDestinationType {
  BankAccount = 'bank_account',
  Card = 'card',
}
